function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  id: "Layer_1-2"
}, React.createElement("rect", {
  fill: "#FFFFFF",
  width: 60,
  height: 60
}), React.createElement("rect", {
  x: 20,
  y: 42,
  fill: "#ADAFB5",
  width: 20,
  height: 2
}), React.createElement("path", {
  fill: "#ADAFB5",
  d: "M29.3,13h1.4c3.5,0,6.3,2.8,6.3,6.3V43l0,0H23l0,0V19.3C23,15.8,25.8,13,29.3,13z"
}), React.createElement("rect", {
  x: 23,
  y: 43,
  fill: "#ADAFB5",
  width: 3,
  height: 4
}), React.createElement("rect", {
  x: 28.5,
  y: 43,
  fill: "#ADAFB5",
  width: 3,
  height: 4
}), React.createElement("rect", {
  x: 34,
  y: 43,
  fill: "#ADAFB5",
  width: 3,
  height: 4
})));

function SvgCoupler(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/coupler.1c499cb3.svg";
export { SvgCoupler as ReactComponent };